import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import logo from "../assets/logo.svg";
import bgimg from "../assets/Login.svg";
import { Eye, EyeOff, ArrowLeft } from "lucide-react";

const Signup = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [role, setRole] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
 const [showPassword, setShowPassword] = useState(false);
  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");

    const [firstName, ...rest] = name.trim().split(" ");
    const lastName = rest.join(" ");

    const payload = {
      email,
      mobile: phone,
      userId: email, // Assuming userId is same as email
      role,
      password,
      active: true,
      firstName,
      middleName: "",
      lastName,
    };

    try {
      const response = await fetch(`${API_URL}auth/register`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("Registration successful! Please login.");
        navigate("/login");
      } else {
        setError(result?.message || "Registration failed.");
        toast.error(result?.message || "Registration failed.");
      }
    } catch (error) {
      console.error("Signup Error:", error);
      setError("Something went wrong.");
      toast.error("Something went wrong.");
    }
  };

  return (
    <div className="flex min-h-screen">
      {/* Back Button for Mobile */}
      <div className="fixed top-4 left-4 z-50 md:hidden">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 px-3 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-all duration-200"
        >
          <ArrowLeft className="w-5 h-5" />
          <span className="font-medium">Back</span>
        </button>
      </div>
      
      {/* Left Background Section */}
      <div className="relative w-1/2 hidden md:flex flex-col bg-cover bg-center overflow-hidden">
        <img
          src={bgimg}
          alt="Background"
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        />
        <div className="relative z-10 flex flex-col h-full px-10">
          <div className="pt-40">
            <img src={logo} alt="Logo" className="w-50" />
          </div>
          <div className="flex-1 flex flex-col items-center text-white text-center">
            <h2 className="text-4xl font-bold text-[#3BBA83] mb-4 mt-8">
              Welcome Back
            </h2>
            <p className="text-base max-w-sm">
              Sign in and step into the future of healthcare—your clinic, fully
              digitized.
            </p>
          </div>
        </div>
      </div>

      {/* Right Form Section */}
      <div className="w-full md:w-1/2 flex justify-center bg-white p-10 mt-14">
        <div className="w-full max-w-md">
          <h2 className="text-3xl font-bold text-blue-900 text-center mb-16">
            Sign Up Account
          </h2>
          {/* <p className="text-sm text-gray-600 text-center mb-16 mt-6">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry.
          </p> */}

          <form className="space-y-5" onSubmit={handleSignup}>
            <input
              type="text"
              placeholder="Enter Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="w-full px-4 py-2 bg-gray-100 border-l-4 border-blue-900 rounded"
            />
            <input
              type="text"
              placeholder="Enter Mobile Number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              className="w-full px-4 py-2 bg-gray-100 border-l-4 border-blue-900 rounded"
            />
            <input
              type="email"
              placeholder="Enter Email Id"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-2 bg-gray-100 border-l-4 border-blue-900 rounded"
            />
            <input
              type="text"
              placeholder="Select Role"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              required
              className="w-full px-4 py-2 bg-gray-100 border-l-4 border-blue-900 rounded"
            />
              <div className="relative">
            <input
             type={showPassword ? "text" : "password"}
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-4 py-2 bg-gray-100 border-l-4 border-blue-900 rounded"
            />
             <div
                  className="absolute inset-y-0 right-3 flex items-center cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </div>
            </div>

            {error && (
              <p className="text-red-500 text-sm text-center">{error}</p>
            )}

            <button
              type="submit"
              className="w-full bg-blue-900 text-white py-2 mt-6 rounded-full hover:bg-blue-800 transition"
            >
              SignUp
            </button>

            <p className="text-center text-sm mt-4">
              Already have an account?{" "}
              <span
                onClick={() => navigate("/login")}
                className="text-green-600 font-medium cursor-pointer"
              >
                Login
              </span>{" "}
              here
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Signup;
